import React from"react"
import {Container, Col, Row} from 'reactstrap'
import constants from '../data/constants'

const SubscriptionOptions = () =>(
    <Container>
        <Row>
            <Col>
                <a href={constants.applePodcastSubscriptionUrl} className="btn btn-block btn-applePodcasts" title="Subscribe on Apple Podcasts">
                    <i className="fab fa-apple" aria-hidden="true"></i>
                    Apple Podcasts
                    <i className="fa fa-long-arrow-alt-right" aria-hidden="true"></i>
                </a>
            </Col>
        </Row>
        <Row>
            <Col>                
                <a href={constants.googlePodcastSubscriptionUrl} className="btn btn-block btn-googlePodcasts" title="Subscribe on Google Podcasts">
                <i className="fab fa-google" aria-hidden="true"></i>
                Google Podcasts
                <i className="fa fa-long-arrow-alt-right" aria-hidden="true"></i>
                </a>
            </Col>
        </Row>
        <Row>
            <Col>
                <a href={constants.androidPodcastSubscriptionUrl} className="btn btn-block btn-androidPodcasts" title="Subscribe on Android">
                    <i className="fab fa-android" aria-hidden="true"></i>
                    Android
                    <i className="fa fa-long-arrow-alt-right" aria-hidden="true"></i>
                </a>
            </Col>
        </Row>
        <Row>
            <Col>                
                <a href={constants.emailPodcastSubscriptionUrl} className="btn btn-block btn-emailPodcasts" title="Subscribe by Email">
                <i className="fa fa-envelope-open" aria-hidden="true"></i>
                By Email
                <i className="fa fa-long-arrow-alt-right" aria-hidden="true"></i>
                </a>
            </Col>
        </Row>
        <Row>
            <Col>                
                <a href="https://completedeveloperpodcast.com/feed/podcast/" className="btn btn-block btn-rssPodcasts" title="Subscribe via RSS">
                <i className="fa fa-rss" aria-hidden="true"></i>
                RSS
                <i className="fa fa-long-arrow-alt-right" aria-hidden="true"></i>
                </a>
            </Col>
        </Row>
        <Row>
            <Col>                
                <a href="https://completedeveloperpodcast.com/podcast-2/subscribe-to-podcast/" className="btn btn-block btn-otherPodcasts" title="More Subscribe Options">
                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                More Subscription Options
                <i className="fa fa-long-arrow-alt-right" aria-hidden="true"></i>
                </a>
            </Col>
        </Row>
    </Container>
)

export default SubscriptionOptions